import React from 'react'
import { Calendar, Copy, Location, Wishlist } from '../../../assests/ExportImageIcon'
import { showToast } from '../../../componants/toast/toastService'

export const formatDateRange = (dateFrom, dateTo) => {
    if (!dateFrom && !dateTo) return 'Flexible dates'
    const fmt = (d) => new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
    if (dateFrom && dateTo) return `${fmt(dateFrom)} - ${fmt(dateTo)}`
    return fmt(dateFrom || dateTo)
}

const WishlistCard = ({ wishlist, onOpen }) => {
    const { name, destination, date_from, date_to, icon: image_url, items_count, is_owner, share_link } = wishlist

    const handleCopyLink = (e) => {
        e.stopPropagation()
        if (!share_link) return
        navigator.clipboard?.writeText(share_link)
        showToast('Share link copied', 'success')
    }

    return (
        <div className='wishlistListCard commonBorder borderRadius20' onClick={onOpen}>
            <div className='wishlistListCard__media'>
                {image_url ? (
                    <img
                        src={image_url}
                        alt={name}
                        onError={(e) => {
                            e.target.style.display = 'none'
                            e.target.nextSibling.style.display = 'flex'
                        }}
                    />
                ) : null}
                <span className='wishlistListCard__fallback' style={{ display: image_url ? 'none' : 'flex' }}>
                    <img src={Wishlist} alt="" />
                </span>
            </div>

            <div className='wishlistListCard__info'>
                <div className='wishlistListCard__top'>
                    <div className='wishlistListCard__name'>{name}</div>
                    {!is_owner && <span className='wishlistListCard__badge'>Shared</span>}
                </div>
                <div className='wishlistListCard__location'>
                    <img src={Location} alt="" /> {destination || '—'}
                </div>
                <div className='wishlistListCard__meta'>
                    <span className='wishlistListCard__metaItem'>
                        <img src={Calendar} alt="" /> {formatDateRange(date_from, date_to)}
                    </span>
                    <span className='wishlistListCard__metaItem'>{items_count} {items_count === 1 ? 'Item' : 'Items'}</span>
                </div>
            </div>

            {share_link && (
                <button type='button' className='wishlistListCard__share' onClick={handleCopyLink} aria-label="Copy share link">
                    <img src={Copy} alt="" />
                </button>
            )}
        </div>
    )
}

export default WishlistCard
